import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../../styles/common/Login.css';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';

const Login = () => {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const { login, error } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        const result = await login(formData.username, formData.password);
        
        if (result.success) {
            // Navigate to role-specific dashboard
            navigate(result.dashboardUrl);
        }
        
        setLoading(false);
    };

    return (
<div className="login-page">

    {/* TOP LOGO */}
    <div className="login-brand">
        <img
            src={logo}
            alt="Black247"
            className="login-logo"
        />
    </div>

    {/* LOGIN CARD */}
    <div className="login-box">

        {/* TITLE */}
        <div className="login-title">
            <span>Login</span>
            <i className="fas fa-sign-in-alt"></i>
        </div>

        {error && (
            <div className="login-alert">
                {error}
            </div>
        )}

        <form onSubmit={handleSubmit}>

            {/* USERNAME */}
            <div className="login-input-group">

                <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    placeholder=""
                    required
                    disabled={loading}
                    autoComplete="username"
                />

                <div className="login-input-icon">
                    <i className="fas fa-user"></i>
                </div>

            </div>

            {/* PASSWORD */}
            <div className="login-input-group">

                <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder=""
                    required
                    disabled={loading}
                    autoComplete="current-password"
                />

                <div className="login-input-icon">
                    <i className="fas fa-key"></i>
                </div>

            </div>

            {/* LOGIN BUTTON */}
            <button
                type="submit"
                className="login-btn"
                disabled={loading}
            >
                <span>
                    {loading ? 'Logging in...' : 'Login'}
                </span>

                <i className="fas fa-sign-in-alt"></i>
            </button>

            {/* DEMO LOGIN */}
            <button
                type="button"
                className="demo-login-btn"
                disabled={loading}
                onClick={() => {
                    // Put your demo login logic here
                    // Example:
                    // setFormData({
                    //     username: 'demo',
                    //     password: 'demo'
                    // });
                }}
            >
                <span>Login with demo ID</span>

                <i className="fas fa-sign-in-alt"></i>
            </button>

        </form>

        {/* RECAPTCHA TEXT */}
        <div className="recaptcha-text">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                Privacy Policy
            </a>
            and
            <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
                Terms of Service
            </a>
            apply.
        </div>

    </div>

    {/* FOOTER */}
<footer className="login-footer">

    <div className="footer-left">
        <Link to="/terms-and-conditions">
            Terms and Conditions
        </Link>

        <Link to="/responsible-gaming">
            Responsible Gaming
        </Link>
    </div>

    <div className="footer-support">
        24X7 Support
    </div>

</footer>

</div>
    );
};

export default Login;